import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
const gtmProductCardClick = ({ productCode, productName, discountAmount, category, category2, price, index }) => {
    const gtmPayload = {
        event: 'select_item',
        ecommerce: {
            items: [
                {
                    item_id: productCode,
                    item_name: productName,
                    discount: discountAmount,
                    index: index !== null && index !== void 0 ? index : 0,
                    item_brand: 'Honda',
                    item_category: category,
                    item_category2: category2,
                    item_category3: 'main product',
                    price,
                    quantity: 1,
                    item_list_name: `find my ${category}`,
                    item_list_id: `find_my_${category}`,
                },
            ],
        },
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export default gtmProductCardClick;
